import type { WindowSize } from 'BreetHelpers';
import { useEffect, useLayoutEffect, useState } from 'react';

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export const useWindowSize = (): WindowSize & { isClient: boolean } => {
	const [windowSize, setWindowSize] = useState<WindowSize>({
		width: 0,
		height: 0,
	});
	const [isClient, setIsClient] = useState(false);

	useIsomorphicLayoutEffect(() => {
		const handleReSize = () => {
			setWindowSize({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		};

		setIsClient(true);
		handleReSize();

		window.addEventListener('resize', handleReSize);

		return () => window.removeEventListener('resize', handleReSize);
	}, []);

	return { ...windowSize, isClient };
};
